<template>
  <el-select
    v-model="budgetId"
    @change="change"
    clearable
    filterable

    placeholder="预算类型">
        <el-option
        v-for="item in budgetList"
        :key="item.budgetId"
        :label="item.budgetName"
        :value="item.budgetId" />
  </el-select>
</template>

<script>
import { getSlotBudget } from '@/api/select'
import { hot } from '@/api/hot'

export default {
  props: {
    modelValue: [Number]
  },
  emits: ['update:modelValue'],
  data () {
    return {
      drag: false,
      budgetList: [],
      budgetId: this.modelValue
    }
  },
  created () {
    this.getSlotBudget()
  },
  methods: {
    getSlotBudget () {
      getSlotBudget().then(res => {
        if (res.code === 200) {
          this.budgetList = res.data
        }
      })
    },
    change (item) {
      const data = {
        maker: 'budgetTypeOnThe',
        onTheOrderId: item
      }
      hot(data)
      const value = item.toString()
      this.$emit('update:modelValue', value)
    },
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>

<style lang="scss" scoped>

</style>
